const icon = require('vue-svgicon');
icon.register({
    'pin': {
        width: 14,
        height: 14,
        viewBox: '0 0 14 14',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2.556 5.519C2.556 7.973 7 12.926 7 12.926s4.445-4.953 4.445-7.407a4.444 4.444 0 10-8.89 0zm.74 0a3.704 3.704 0 117.408 0C10.704 7.564 7 11.815 7 11.815S3.296 7.564 3.296 5.519zM7 7.74a2.222 2.222 0 110-4.445 2.222 2.222 0 010 4.445zM5.52 5.519a1.482 1.482 0 112.963 0 1.482 1.482 0 01-2.963 0z" _fill="#000"/>`,
    },
});
